import React from 'react';

const PaymentModeFormModal = React.lazy(() => import('../components/FormModal'));
const paymentModeModalRegistry = {
    core_paymentModeId: PaymentModeFormModal
};
export default paymentModeModalRegistry;
